import { MobilePermissionEnum } from 'constants-permissions';
import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

export const SaltoSVNDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.SaltoSVN,
  hasCustomUI: true,
  friendlyName: 'SaltoSvn Access Control',
  description: `Defines the properties required for a Salto SVN integration.`,
  category: IntegrationCategoryEnum.AccessControl,
  platforms: [PlatformEnum.Mobile],
  type: IntegrationTypeEnum.SDK,
  settings: {},
  properties: {
    supportPage: {
      friendlyName: 'Support Page',
      type: 'Content',
    },
  },
  mobilePermissions: [
    MobilePermissionEnum.Bluetooth,
    MobilePermissionEnum.SecureDevice,
  ],
  // Google requires us to use specific language requesting background location access before we load the system prompts
  mobilePermissionsRequest:
    'To unlock doors, Workplace Access requires these device settings to be enabled, including accessing your location when the application is not in use:',
};

export const definition = SaltoSVNDefinition;
